import { render } from "./AdminPromoCodesList.vue?vue&type=template&id=766f322a&scoped=true&ts=true"
import script from "./AdminPromoCodesList.vue?vue&type=script&lang=ts"
export * from "./AdminPromoCodesList.vue?vue&type=script&lang=ts"

import "./AdminPromoCodesList.vue?vue&type=style&index=0&id=766f322a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766f322a"]])

export default __exports__